import { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';

import { ROUTES } from 'theSource/app/routes';
import {
  AvatarProfilePictureImgStyled,
  PopoverStyled,
  ProfilePictureImgStyled,
} from './DesktopPopOverStyled';
import { LogoutButton } from 'theSource/components/LogoutButton';
import { Language } from 'features/HomePage/components/Language';
import { PsButtonTuner } from 'stencilSetup';
import { NavLinks } from 'features/HomePage/components/NavLinks';
import {
  avatarList,
  hairColorPalette,
  shirtColorPalette,
  skinColorPalette,
} from 'enrollment/app/constants';
import { FamilyDrawerDisplayPicture } from 'enrollment/features/Family/FamilyDetailsPage/FamilyDrawerDisplayPicture';
import { selectMfaEnabled } from 'theSource/features';
import './DesktopPopOver.css';

export const DesktopPopOver = () => {
  const { t } = useTranslation('common');
  const [IsPopoverOpen, setIsPopoverOpen] = useState(false);

  const mfaEnabled = useSelector(selectMfaEnabled);

  const togglePopover = () => {
    setIsPopoverOpen(!IsPopoverOpen);
  };
  const closePopover = () => setIsPopoverOpen(false);

  const ref = useRef(null);
  const id = IsPopoverOpen ? 'open-desktop-popover' : undefined;
  const popoverLinks = Object.values(ROUTES.additional.account);
  const popoverLinksFiltered = mfaEnabled
    ? popoverLinks
    : popoverLinks.filter(
        (link) =>
          link.name !== 'navigation.additional:account.securityPreferencesTitle'
      );

  const profileAvatar = useSelector(
    (state: any) => state.enrollment?.subscriber?.subscriber_profile?.avatar
  );

  const profilePicture = useSelector(
    (state: any) =>
      state.enrollment?.subscriber?.subscriber_profile?.profile_picture
  );

  const avatarName =
    typeof profileAvatar === 'string' ? profileAvatar.split('_')[0] : '';
  const avatarPicture = avatarList?.filter(
    (item) => profileAvatar && avatarName === item.name
  );
  const avatarSkincolor = skinColorPalette?.filter(
    (item) =>
      typeof profileAvatar === 'string' &&
      profileAvatar.split('_')[1] === item.name
  );

  const avatarHairColor = hairColorPalette?.filter(
    (item) =>
      typeof profileAvatar === 'string' &&
      profileAvatar.split('_')[2] === item.name
  );

  const avatarShirtColor = shirtColorPalette?.filter(
    (item) =>
      typeof profileAvatar === 'string' &&
      profileAvatar.split('_')[3] === item.name
  );

  return (
    <div className="d-none d-lg-inline-block">
      {profileAvatar ? (
        <AvatarProfilePictureImgStyled
          ref={ref}
          onClick={togglePopover}
          aria-label={t('profileButton')}
        >
          <FamilyDrawerDisplayPicture
            saveAvatarName={avatarPicture[0]?.name}
            saveAvatarSkinTone={avatarSkincolor[0]?.colorCode}
            saveAvatarHairColor={avatarHairColor[0]?.colorCode}
            saveAvatarShirtColor={avatarShirtColor[0]?.colorCode}
            size={44}
          />
        </AvatarProfilePictureImgStyled>
      ) : profilePicture ? (
        <button
          ref={ref}
          onClick={togglePopover}
          aria-label={t('profileButton')}
          className="profile-button"
        >
          <ProfilePictureImgStyled
            src={profilePicture}
            alt=" "
            aria-hidden="true"
            role="presentation"
          />
        </button>
      ) : (
        <PsButtonTuner
          buttonId="settings-button"
          label={t('profileButton')}
          level="tertiary"
          isIcon={true}
          icon="user-circle ph-duotone"
          onClick={togglePopover}
          ref={ref}
        />
      )}

      {IsPopoverOpen &&
        createPortal(
          <PopoverStyled
            data-testid={id}
            open={IsPopoverOpen}
            anchorEl={ref.current}
            onClose={closePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            role="dialog"
            aria-modal="true"
            aria-label={t('userSettings')}
          >
            <section aria-label="Account management">
              <div className="account-group">
                <NavLinks navRoutes={popoverLinksFiltered} />
              </div>
              <div className="mt-0 mb-3 mx-3">
                <Language />
              </div>
              <hr />
              <div className="m-3">
                <LogoutButton
                  data-testid="log-out-button-desktop"
                  dataTestId="log-out-button-desktop"
                />
              </div>
            </section>
          </PopoverStyled>,
          document.body
        )}
    </div>
  );
};
